<template>
  <div class="aside-box">
    <div class="floor-name">
      <div class="info-name">
        <span style="opacity: 0">*</span>
        <p>楼层名称</p>
      </div>
      <div class="info-content">
        <el-input
          v-model.trim="info.name"
          placeholder="请输入楼层名称"
          maxlength="6"
          show-word-limit
          class="floor-name-input"
          @input="updateVuex()"
        ></el-input>
      </div>
      <div class="info-name" style="margin-top: 40px">
        <span style="opacity: 0">*</span>
        <p>内容</p>
      </div>
      <div class="info-content">
        <div class="add-content-li" @click="openDialogEditor()">
          <img
            src="../../../assets/images/pc-decoration/create-swiper-icon.png"
            alt=""
            class="edit-icon"
          />
          <p>编辑</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopCenterAdminWebMAsideNav",
  props: {
    floor: {
      type: Object,
    },
  },
  data() {
    return {
      info: {
        id: 206,
        name: "快捷导航",
        count: 1, // 展示数量
        maxCount: 8, // 最大展示数量
        contentList: [
          {
            navName: "",
            navImg: "",
            navUrl: "",
          },
        ], // 楼层内容列表 默认一个
      },
      navList: [],
    };
  },
  watch: {
    "floor.index": {
      handler() {
        // 获取快捷导航楼层数据
        this.info = JSON.parse(
          JSON.stringify(
            this.$store.state.mDecoration.floorList[this.floor.index]
          )
        );
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {},

  methods: {
    // 更新数据到vuex中
    updateVuex() {
      const list = JSON.parse(
        JSON.stringify(this.$store.state.mDecoration.floorList)
      );
      list[this.floor.index] = this.info;
      this.$store.commit("mDecoration/setFloorList", list);
    },
    // 打开富文本楼层编辑弹窗
    openDialogEditor() {
      // 更新数据到vuex中
      this.$store.commit("mDecoration/setDialogType", "floorEditor");
    },
  },
};
</script>

<style lang="scss" scoped>
.aside-box {
  .floor-name,
  .floor-style {
    margin-bottom: 40px;
  }
  .info-name {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 20px;

    span {
      margin-right: 4px;
      font-size: 15px;
      font-weight: 600;
      color: #fe4509;
    }
    p {
      font-size: 15px;
      font-weight: 500;
      color: #606266;
    }
  }
  .info-content {
    padding-left: 12px;
    .add-content-li {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 310px;
      height: 32px;
      margin-bottom: 30px;
      background: #ffffff;
      border: 1px solid #5a83ff;
      border-radius: 5px;
      cursor: pointer;

      span {
        font-size: 20px;
        font-weight: 500;
        transform: translate(-2px, -2px);
        color: #5a83ff;
      }

      p {
        font-size: 14px;
        color: #5a83ff;
      }
      div {
        font-size: 12px;
        color: #c4c8d0;
      }

      .edit-icon {
        width: 9px;
        height: 12px;
        margin-right: 5px;
      }
    }
  }
}
</style>
